import React from "react";
import { useCombinedStore } from "../store";
import * as AlfredoStyles from "../styles/components/SupplyAppointment";

const LastOptions: React.FC = () => {
  return (
    <AlfredoStyles.LastOptionsContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>move_down</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Movimentações de Materiais</AlfredoStyles.Title>
      </AlfredoStyles.Card>
    </AlfredoStyles.LastOptionsContainer>
  );
};

export default LastOptions;
